"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChatSessionContext = exports.ChatSessionContextProvider = exports.ChatSessionContext = exports.EventContextProvider = exports.EventContext = exports.GaiaPostHogProvider = exports.PostHogSuperPropertiesRegistrar = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_2 = require("@posthog/react");
var posthog_js_1 = __importDefault(require("posthog-js"));
var index_1 = require("../../config/index");
var environment_1 = require("../../config/environment");
var browser_1 = require("../../react-universal/browser");
var selectors_1 = require("../../services/auth/selectors");
var selectors_2 = require("../../services/user/selectors");
var index_2 = require("../../services/user/index");
var selectors_3 = require("../../services/user-account/selectors");
var selectors_4 = require("../../services/app/selectors");
var index_3 = require("../../services/country/index");
var index_4 = require("../../environment/index");
// useVideoState lives in OracleCommons (it's a video-player helper, not PostHog code).
// usePostHogEvent imports it for video-event enrichment — cross-directory but intentional.
var queries_generated_1 = require("../OracleCommons/queries.generated");
// ============================================================================
// Module-level Initialization
// ============================================================================
/**
 * Module-level PostHog initialization.
 * Runs when JavaScript is parsed, similar to the Mustache template
 * loading PostHog in the HTML head.
 */
var config = (0, environment_1.isBrowser)() ? (0, index_1.get)() : null;
var isPostHogEnabled = !!((_a = config === null || config === void 0 ? void 0 : config.features) === null || _a === void 0 ? void 0 : _a.posthog);
var posthogApiKey = config === null || config === void 0 ? void 0 : config.posthogApiKey;
// Staging runs PostHog for flag evaluation but suppresses event capture
// (and session recording) so stage usage does not pollute production analytics.
var origin = (_b = config === null || config === void 0 ? void 0 : config.origin) !== null && _b !== void 0 ? _b : '';
var isStaging = origin.includes('www-stg-4b2c19');
// Get bootstrapped feature flags and distinctID from server-side evaluation
var appData = (0, environment_1.isBrowser)() ? (0, browser_1.getAppData)() : null;
var bootstrapData = ((_c = appData === null || appData === void 0 ? void 0 : appData.hydrate) === null || _c === void 0 ? void 0 : _c.posthogBootstrap) || {};
var bootstrappedFlags = bootstrapData.featureFlags || {};
var bootstrappedDistinctID = bootstrapData.distinctID;
var bootstrappedIsIdentifiedID = bootstrapData.isIdentifiedID || false;
// Don't initialize PostHog in test environments to prevent background timers
// from keeping the Node.js event loop alive after tests complete
var isTestEnvironment = process.env.NODE_ENV === 'test' || process.env.BROWSER_TEST;
if ((0, environment_1.isBrowser)() && isPostHogEnabled && posthogApiKey && !isTestEnvironment) {
    if (isStaging) {
        // eslint-disable-next-line no-console
        console.log('[posthog] staging: events suppressed, flags active');
    }
    posthog_js_1.default.init(posthogApiKey, __assign(__assign({ 
        // Use managed reverse proxy to bypass ad blockers and improve event capture
        // Routes events through our own domain instead of PostHog's domain
        api_host: 'https://ph.gaia.com', 
        // Keep UI links (e.g., "Open in PostHog") pointing to the correct instance
        ui_host: 'https://us.posthog.com', person_profiles: 'identified_only', capture_pageview: false, capture_pageleave: false, autocapture: false, capture_performance: false, 
        // Since we bootstrap feature flags server-side, disable all automatic flag
        // evaluation (init, post-identify reload, reloadFeatureFlags). The /flags
        // endpoint is still called so session recording and surveys keep working,
        // but the server skips flag computation — flags come only from bootstrap.
        advanced_disable_feature_flags: true }, (isStaging && { before_send: function () { return null; } })), { 
        // Session recording uses a separate transport that bypasses before_send.
        // Disable it explicitly on staging.
        disable_session_recording: isStaging, 
        // Session recording controlled by PostHog UI triggers
        // See: Session Replay Settings -> Recording Conditions
        // Trigger: Feature flag "enable-session-recording" = true
        // Bootstrap feature flags and distinctID from server-side evaluation
        // CRITICAL: With person_profiles: 'identified_only', we must include distinctID
        // and isIdentifiedID in bootstrap to prevent events from being dropped
        // This ensures PostHog knows the user is identified from initialization
        bootstrap: __assign(__assign({}, (bootstrappedDistinctID && {
            distinctID: bootstrappedDistinctID,
            isIdentifiedID: bootstrappedIsIdentifiedID,
        })), { featureFlags: bootstrappedFlags }) }));
}
// ============================================================================
// User Identification Component
// ============================================================================
// Module-level guard: only call identify() once per page load to prevent
// redundant $set events on SPA navigation (each identify() = 1 billable event).
// Resets on full page reload, which is fine — identify is needed once per session.
var identifiedUid = null;
/**
 * Handles automatic user identification based on Redux auth state.
 * Must be rendered inside the official PostHogProvider.
 */
var PostHogUserIdentifier = function (_a) {
    var _b;
    var children = _a.children;
    var posthogClient = (0, react_2.usePostHog)();
    var auth = (0, react_redux_1.useSelector)(selectors_1.selectAuth);
    var uid = auth === null || auth === void 0 ? void 0 : auth.get('uid');
    var username = auth === null || auth === void 0 ? void 0 : auth.get('username');
    var jwt = auth === null || auth === void 0 ? void 0 : auth.get('jwt');
    var country = (0, react_redux_1.useSelector)(selectors_1.selectUserCountry);
    var email = (0, react_redux_1.useSelector)(selectors_2.selectEmail);
    // Fetch authoritative tenure from GraphQL (skipped when not logged in)
    var postHogPropsData = (0, queries_generated_1.useGetCurrentUserPostHogPropertiesQuery)({
        skip: !uid || !jwt,
        context: { jwt: jwt },
    }).data;
    var userInfo = (_b = postHogPropsData === null || postHogPropsData === void 0 ? void 0 : postHogPropsData.userInfoCurrent) === null || _b === void 0 ? void 0 : _b.userInfo;
    var userTenureDays = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userTenureDays;
    var videosLast7Days = userInfo === null || userInfo === void 0 ? void 0 : userInfo.videosLast7Days;
    var daysWithViewershipLast7Days = userInfo === null || userInfo === void 0 ? void 0 : userInfo.daysWithViewershipLast7Days;
    var videoCompletionRate = userInfo === null || userInfo === void 0 ? void 0 : userInfo.videoCompletionRate;
    var medianWatchTimePerWeek = userInfo === null || userInfo === void 0 ? void 0 : userInfo.medianWatchTimePerWeek;
    var engagementCohort = userInfo === null || userInfo === void 0 ? void 0 : userInfo.engagementCohort;
    var aiChatUsageFrequency = userInfo === null || userInfo === void 0 ? void 0 : userInfo.aiChatUsageFrequency;
    var aiGuideInteractionCount = userInfo === null || userInfo === void 0 ? void 0 : userInfo.aiGuideInteractionCount;
    // Conservative defaults: assume GDPR applies, assume not employee
    var isGdprCountry = country ? index_3.GDPR_COUNTRIES.includes(country) : true;
    var isEmployee = email ? email.endsWith('@gaia.com') : false;
    // Detect automated test accounts for filtering in PostHog
    var isTestAccount = username ? username.startsWith('automation-') : false;
    // Device detection (stable for session)
    var deviceType = (0, react_1.useMemo)(function () {
        var device = (0, index_4.getDeviceType)();
        // Map to PostHog expected values (lowercase)
        if (device === 'Desktop')
            return 'desktop';
        if (device === 'iPhone' || device === 'Android')
            return 'mobile';
        if (device === 'iPad')
            return 'tablet';
        return 'unknown';
    }, []);
    // CRITICAL: Identify user once with all properties
    // According to PostHog docs: "You only need to call identify once per session"
    // Wait for GraphQL data before identifying to avoid multiple identify() calls
    (0, react_1.useEffect)(function () {
        if (!uid) {
            identifiedUid = null;
            posthogClient.reset();
            return undefined;
        }
        // Wait for required properties: username and GraphQL data
        // Since bootstrap already marks user as identified, this delay is safe
        if (!username || userTenureDays === undefined) {
            return undefined;
        }
        // Skip if we already identified this user this page session.
        // Prevents redundant $set events on SPA navigation remounts.
        if (identifiedUid === String(uid)) {
            return undefined;
        }
        identifiedUid = String(uid);
        // Call identify() ONCE with all available properties
        // PostHog requires uid to be a string, not a number
        posthogClient.identify(String(uid), __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ user_id: uid, // Add user_id as property for filtering in PostHog UI
            username: username }, (email && { email: email })), (country && { country: country })), { is_gdpr_country: isGdprCountry, is_employee: isEmployee, is_test_account: isTestAccount, device_type: deviceType, platform: 'web', 
            // GraphQL-sourced engagement properties
            user_tenure_days: userTenureDays }), (videosLast7Days !== undefined && {
            videos_last_7_days: videosLast7Days,
        })), (daysWithViewershipLast7Days !== undefined && {
            days_with_viewership_last_7_days: daysWithViewershipLast7Days,
        })), (videoCompletionRate !== undefined && {
            video_completion_rate: videoCompletionRate,
        })), (medianWatchTimePerWeek !== undefined && {
            median_watch_time_per_week: medianWatchTimePerWeek,
        })), (engagementCohort !== undefined && {
            engagement_cohort: engagementCohort,
        })), (aiChatUsageFrequency !== undefined && {
            ai_chat_usage_frequency: aiChatUsageFrequency,
        })), (aiGuideInteractionCount !== undefined && {
            ai_guide_interaction_count: aiGuideInteractionCount,
        })));
        // PostHog will automatically handle session recording based on UI triggers
        // No need to manually call reloadFeatureFlags() or startSessionRecording()
        // Flag reload after identify() is disabled via advanced_disable_feature_flags —
        // bootstrapped values from SSR are already evaluated with the user's identity
        return undefined;
    }, [
        posthogClient,
        uid,
        username,
        email,
        country,
        isGdprCountry,
        isEmployee,
        isTestAccount,
        userTenureDays,
        deviceType,
        videosLast7Days,
        daysWithViewershipLast7Days,
        videoCompletionRate,
        medianWatchTimePerWeek,
        engagementCohort,
        aiChatUsageFrequency,
        aiGuideInteractionCount,
    ]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
// ============================================================================
// Layer 1 Super-Properties Registrar
// ============================================================================
/**
 * Registers Layer 1 PostHog super-properties whenever the underlying Redux
 * values change. Super-properties are attached to every subsequent event
 * automatically by the PostHog client (see `posthog.register`). Nullish values
 * are omitted from the registered payload so PostHog does not overwrite an
 * existing super-property with `null` / `undefined`.
 *
 * Scope: the eight Layer 1 properties defined in
 * `docs/analytics/design.md` — `user_id`, `gaia_uuid`, `app_version`,
 * `user_language`, `guest_phase`, `membership_status`, `user_plan_sku`,
 * `plan_type`. Each maps to one Redux selector.
 *
 * `ai_persona` is intentionally NOT a Layer 1 super-property: it is per-
 * conversation (Layer 3), locked at chat entry, and travels with the in-chat
 * context via `ChatSessionContextProvider`.
 */
var PostHogSuperPropertiesRegistrar = function (_a) {
    var children = _a.children;
    var posthogClient = (0, react_2.usePostHog)();
    // `selectGuestPhase` returns boolean today (true === in-trial-segment).
    // The other Layer 1 selectors return string-or-nullish. Both are passed
    // through to `posthog.register()` verbatim; the conditional spread below
    // omits any nullish/false value.
    var guestPhase = (0, react_redux_1.useSelector)(selectors_3.selectGuestPhase);
    var membershipStatus = (0, react_redux_1.useSelector)(selectors_3.selectMembershipStatus);
    var userLanguage = (0, react_redux_1.useSelector)(index_2.selectUserLanguagePrimary);
    var auth = (0, react_redux_1.useSelector)(selectors_1.selectAuth);
    var userId = auth === null || auth === void 0 ? void 0 : auth.get('uid');
    var gaiaUuid = (0, react_redux_1.useSelector)(selectors_2.selectUserExternalId);
    var userPlanSku = (0, react_redux_1.useSelector)(selectors_3.selectUserPlanSku);
    var planType = (0, react_redux_1.useSelector)(selectors_3.selectPlanType);
    var appVersion = (0, react_redux_1.useSelector)(selectors_4.selectAppVersion);
    (0, react_1.useEffect)(function () {
        if (!posthogClient)
            return;
        posthogClient.register(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (guestPhase && { guest_phase: guestPhase })), (membershipStatus && { membership_status: membershipStatus })), (userLanguage && { user_language: userLanguage })), (userId && { user_id: userId })), (gaiaUuid && { gaia_uuid: gaiaUuid })), (appVersion && { app_version: appVersion })), (userPlanSku && { user_plan_sku: userPlanSku })), (planType && { plan_type: planType })));
    }, [
        guestPhase,
        membershipStatus,
        userLanguage,
        userId,
        gaiaUuid,
        appVersion,
        userPlanSku,
        planType,
        posthogClient,
    ]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.PostHogSuperPropertiesRegistrar = PostHogSuperPropertiesRegistrar;
/**
 * GaiaPostHogProvider wraps the official @posthog/react PostHogProvider.
 * - Passes the pre-initialized posthog client to the official provider
 * - Handles user identification automatically via PostHogUserIdentifier
 *
 * When PostHog is disabled (not initialized), capture calls are no-ops.
 */
var GaiaPostHogProvider = function (_a) {
    var children = _a.children;
    if (!isPostHogEnabled) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(react_2.PostHogProvider, { client: posthog_js_1.default },
        react_1.default.createElement(PostHogUserIdentifier, null,
            react_1.default.createElement(exports.PostHogSuperPropertiesRegistrar, null, children))));
};
exports.GaiaPostHogProvider = GaiaPostHogProvider;
exports.EventContext = (0, react_1.createContext)(null);
/**
 * Provides event context to child components. All events captured via usePostHogEvent() will
 * automatically include this context.
 *
 * @example
 * <EventContextProvider context="ai_guide_on_the_side">
 *   <VideoGuideChat />
 * </EventContextProvider>
 */
var EventContextProvider = function (_a) {
    var context = _a.context, children = _a.children;
    return (react_1.default.createElement(exports.EventContext.Provider, { value: context }, children));
};
exports.EventContextProvider = EventContextProvider;
exports.ChatSessionContext = (0, react_1.createContext)(null);
/**
 * Provides chat-session context (session id, optional conversation title,
 * locked-at-entry persona, backend chat-channel name) to descendants. Read
 * via {@link useChatSessionContext}. Mirrors the {@link EventContextProvider}
 * pattern.
 *
 * @example
 * <ChatSessionContextProvider
 *   chatSessionId={sessionId}
 *   conversationTitle={title}
 *   aiPersona="sage"
 *   chatExperienceName="Tarot"
 * >
 *   <ChatSurface />
 * </ChatSessionContextProvider>
 */
var ChatSessionContextProvider = function (_a) {
    var chatSessionId = _a.chatSessionId, _b = _a.conversationTitle, conversationTitle = _b === void 0 ? null : _b, _c = _a.aiPersona, aiPersona = _c === void 0 ? null : _c, _d = _a.chatExperienceName, chatExperienceName = _d === void 0 ? null : _d, children = _a.children;
    var value = (0, react_1.useMemo)(function () { return ({
        chatSessionId: chatSessionId,
        conversationTitle: conversationTitle !== null && conversationTitle !== void 0 ? conversationTitle : null,
        aiPersona: aiPersona !== null && aiPersona !== void 0 ? aiPersona : null,
        chatExperienceName: chatExperienceName !== null && chatExperienceName !== void 0 ? chatExperienceName : null,
    }); }, [chatSessionId, conversationTitle, aiPersona, chatExperienceName]);
    return (react_1.default.createElement(exports.ChatSessionContext.Provider, { value: value }, children));
};
exports.ChatSessionContextProvider = ChatSessionContextProvider;
/**
 * Reads chat-session context. When no provider is mounted, returns an
 * all-`null` value so consumers don't have to null-check the wrapper.
 */
var useChatSessionContext = function () {
    var value = (0, react_1.useContext)(exports.ChatSessionContext);
    if (!value) {
        return {
            chatSessionId: null,
            conversationTitle: null,
            aiPersona: null,
            chatExperienceName: null,
        };
    }
    return value;
};
exports.useChatSessionContext = useChatSessionContext;
